import { Box, Typography, Divider } from "@mui/material";
import { Link } from "react-router-dom";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";

export default function One() {
	const content = (
		<Box sx={{ my: "2rem", px: "1rem" }}>
			<Box>
				{" "}
				<Typography sx={{ textAlign: "left" }}>
					Lets have all the work done for you through your earning journey.{" "}
					<Link className="  bg-red-800  text-white   font-medium py-[0.3rem]  px-[0.7rem]">
						Fund account now{" "}
						<KeyboardArrowRightIcon className="animate-pulse" />
					</Link>
				</Typography>
			</Box>

			<Divider sx={{ width: "20%", bgcolor: "yellow", my: "1rem" }} />

			<Box>
				<Typography sx={{ textAlign: "left" }}>
					already funded your account ? choose from the available crypto mining
					bots below to initiate your earning journey
					{/* <Link className="  bg-red-800  text-white   font-medium py-[0.3rem]  px-[0.7rem]">
                        Fund account now{" "}
                        <KeyboardArrowRightIcon className="animate-pulse" />
                    </Link> */}
				</Typography>
			</Box>
		</Box>
	);

	return content;
}
